import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import WhyIGrade from "../components/WhyIGrade";
import { Pillars, WhoCanRegister, Process } from "../components/Sections";
import Universities from "../components/Universities";
import CountdownTimers from "../components/CountdownTimers";
import CourseFinderQuiz from "../components/CourseFinderQuiz";
import ComparisonTable from "../components/ComparisonTable";
import Trust from "../components/Trust";
import CTABanner from "../components/CTABanner";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import { Footer, WhatsAppFloat } from "../components/Footer";
import PromoPopup from "../components/PromoPopup";
import Blog from "../components/Blog";

export default function Home() {
  return (
    <>
      <Navbar />
      <Hero />
      <Marquee />
      <WhyIGrade />
      <CourseFinderQuiz />
      <Pillars />
      <Universities />
      <CountdownTimers />
      <ComparisonTable />
      <WhoCanRegister />
      <Trust />
      <Process />
      <Blog />
      <CTABanner />
      <FAQ />
      <Contact />
      <Footer />
      <WhatsAppFloat />
      <PromoPopup />
    </>
  );
}